import { useModals } from '@customerio/pluma-components/react';
import { useCreditsPurchasePageName } from '@/features/billing';
import { FlexPlanSheetModal } from '@/features/flex-plan-sheet';
import { useFlexAddFunds } from './use-flex-add-funds';

export function useOpenFlexPricing(): () => void {
  const modals = useModals();
  const { action } = useFlexAddFunds(useCreditsPurchasePageName());

  return () => {
    modals.open(FlexPlanSheetModal, { addFunds: action }, { shouldCloseOnUnmount: true });
  };
}
